export default {
  myLocation: {
    stopShowingCurrentLocation: 'Show your location',
    showCurrentLocation: 'Click to show your current location',
    yourCurrentLocation: 'Your current location',
    continuously: 'Continuously',
    onlyOnce: 'Only once',
    continuouslyLocation: 'Refresh your position every 2 seconds',
    onlyOnceLocation: 'Acquire your position only once',
    myPositionToolTip:
      'Activate location to show your position and find nearby places more easily',
    showDangerousAreas: 'Dangerous Areas',
    Settings: 'Settings',
    CycleLanes: 'Cycle Lanes'
  }
}
